/**
 * Asynchronously loads the component for VerifyShortLinkPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
